// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__19FBv","box":"WorkspacesBox_box__gZZCF","node":"WorkspacesBox_node__vruFH"};